import { render, staticRenderFns } from "./SidemenuEntry.vue?vue&type=template&id=873f859e&"
import script from "./SidemenuEntry.vue?vue&type=script&lang=ts&"
export * from "./SidemenuEntry.vue?vue&type=script&lang=ts&"
import style0 from "./SidemenuEntry.vue?vue&type=style&index=0&id=873f859e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports